import FItemNumber from '../FItem/Number';
import component from './component.vue';

export default class FNumber extends FItemNumber {
  __component = component;

  constructor(props = {}) {
    super(props);
    this.btn = props.btn || 'max';
  }
}
